import Vue from 'vue'
import Router from 'vue-router'
import MainBanner from '@/components/MainBanner'
import Blog from '@/components/Blog'
import BlogStandalone from '@/components/BlogStandalone'
import BlogDetail from '@/components/BlogDetail'
import About from '@/components/About'
import ClunForest from '@/components/ClunForest'
import BreedingYear from '@/components/BreedingYear'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      components: {
        banner: MainBanner,
        content: Blog
      }
    }, { 
      path: '/blog',
      name: 'BlogStandalone',
      components: { 
        content: BlogStandalone        
      }
    }, { 
      path: '/blog_item/:id',
      name: 'BlogDetail',
      components: { 
        content: BlogDetail        
      },
      props: { content: true, contact_us: false }
    }, { 
      path: '/about',
      name: 'About',
      components: { 
        content: About        
      }
    }, { 
      path: '/clun_forest',
      name: 'ClunForest',
      components: { 
        content: ClunForest        
      }
    }, { 
      path: '/breeding_year',
      name: 'BreedingYear',
      components: { 
        content: BreedingYear        
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js